import { ReactNode } from "react";
import { DateValue } from "@internationalized/date";
import { CalendarCell, CalendarGrid, Heading } from "react-aria-components";

import { ChevronLeft, ChevronRight } from "components/icons/generated";

import Box from "../Box";
import ButtonIcon from "../ButtonIcon";
import Tooltip from "../Tooltip";
import styles from "./styles.module.css";

type DatepickerCalendarContentProps = {
  maxValue?: DateValue;
  maxDateTooltip?: ReactNode;
};

const DatepickerCalendarContent = ({
  maxValue,
  maxDateTooltip,
}: DatepickerCalendarContentProps) => (
  <>
    <Box align="center" justify="between" margin="0 0 large 0">
      <ButtonIcon slot="previous" icon={ChevronLeft} tooltipMode="parent" variant="ghost">
        Previous
      </ButtonIcon>
      <Heading className={styles.calendarHeading} />
      <ButtonIcon slot="next" icon={ChevronRight} tooltipMode="parent" variant="ghost">
        Next
      </ButtonIcon>
    </Box>
    <CalendarGrid weekdayStyle="short">
      {(date) => (
        <Tooltip
          active={!!maxDateTooltip && !!maxValue && date.compare(maxValue) > 0}
          widthMode="maxWidthSm"
          on={(props) => <CalendarCell {...props} className={styles.calendarCell} date={date} />}
        >
          {maxDateTooltip}
        </Tooltip>
      )}
    </CalendarGrid>
  </>
);

DatepickerCalendarContent.displayName = "DS.Datepicker.CalendarContent";

export default DatepickerCalendarContent;
